
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 18","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0L0 6l4.364 2.18v6L12 18l7.636-3.82v-6l2.182-1.09V14H24V6L12 0zm7.44 6L12 9.72 4.56 6 12 2.28 19.44 6zm-1.986 6.99L12 15.72l-5.455-2.73V9.27L12 12l5.454-2.73v3.72z"}})])
          )
        }
      }
    